<template>
  <div class="preview-table">
    <h3 class="table-title">数据预览最多展示100条数据</h3>
    <vxe-table border :data="data.originalList" :height="tableHeight">
      <vxe-column fixed="left" type="seq" width="80" align="center" title="序号"></vxe-column>
      <template v-for="item in column">
        <vxe-column
          :field="item.dataIndex || item.key"
          :title="item.title"
          :min-width="item.width"
          align="center"
          show-overflow="tooltip"
        ></vxe-column>
      </template>
      <template #empty>
        <a-empty :image="simpleImage">
          <template #description>暂无数据</template>
        </a-empty>
      </template>
    </vxe-table>
    <a-row type="flex" align="center" style="margin: 20px 0 0">
      <a-col>
        <a-button @click="updateStep(0)">上一步</a-button>
        <a-button type="primary" @click="updateStep(2)">下一步</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "DataPreview",
});
</script>

<script lang="ts" setup>
import { Empty } from "ant-design-vue";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  tableHeight: {
    type: Number,
    default: 200,
  },
  columns: {
    type: Array,
    default: () => [],
  },
});

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

const emit = defineEmits(["setSteps"]);

const column = props.columns;

function updateStep(step: number) {
  emit("setSteps", step);
}
</script>

<style lang="less" scoped>
.preview-table {
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  height: calc(100% - 72px);
  overflow-y: auto;
  .table-title {
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
  }
  .vxe-table {
    min-height: 200px;
    margin-bottom: 10px;
  }
}
</style>
